import { Close, DownloadOutlined, FilterAlt, ReplayCircleFilled, } from '@mui/icons-material'
import { Input, Table, Typography, Select, Button, Badge, Drawer, Checkbox, Divider, Space, Form, Tooltip, DatePicker } from 'antd'
import React, { useEffect, useState } from 'react'
import "../assets/styles/viewOrganisation.scss"
import { getListViewOrg, getFilteredOrg, getAllOrgName, getListAllCities, getFilteredOrgDocsDownload, getListViewOrgDocsDownload, getAof, getBillingsCa, searchOrg, downloadMainBillings } from "../services/httpCalls"
import { useRecoilState, useSetRecoilState } from 'recoil'
import { billingsOrgId, showloader } from "../store/gloabalState";
import useNotify from "../utils/useNotify";
import FileDownload from "js-file-download";
import { useNavigate } from "react-router-dom";
import { EyeOutlined, EditOutlined, FileSyncOutlined } from "@ant-design/icons"
import { Link } from "react-router-dom";
import SubTable from '../components/subTable'

const CaBillings = () => {
    const { Option } = Select
    const { RangePicker } = DatePicker;
    const [open, setOpen] = useState(false);
    const [billingsMain, setBillingsMain] = useState()
    const [filterValues, setFilterValues] = useState()
    const [queryTermSearch, setQueryTermSearch] = useState('')
    const [queryDateRange, setQueryDateRange] = useState()
    const [querySearchRefresh, setQuerySearchRefresh] = useState(false)
    const [filterRefresh, setFilterRefresh] = useState(false)
    const [totalCount, setTotalCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(0)
    const [selectedOrgId, setSelectedOrgId] = useRecoilState(billingsOrgId)
    const [orgList, setOrgList] = useState([])
    const [form] = Form.useForm();
    const setShowLoader = useSetRecoilState(showloader);
    const notify = useNotify()
    const navigate = useNavigate()

    const showSubtable = (orgId, orgName) => {
        setSelectedOrgId({
            id: orgId,
            name: orgName
        })
        setOpen(true);
    };

    const hideSubtable = () => {
        setOpen(false);
    };

    const colsCa = [
        {
            title: "View",
            key: "view",
            align: "center",
            width: "80px",
            render: (val, record) => (
                <EyeOutlined
                    onClick={() => showSubtable(record?.orgId, record?.customerName)}
                    style={{
                        color: "#2862FF",
                        marginRight: '.8rem',
                        fontWeight: '500',
                        fontSize: '18px'
                    }}
                />
            )
        },
        {
            title: "Company Name",
            key: "name",
            align: "center",
            width: "150px",
            render: (val, record) => (
                record?.customerName ? record?.customerName : "--"
            ),
        },
        {
            title: "Total No. Bills",
            key: "total",
            align: "center",
            width: "100px",
            render: (val, record) => (
                record?.totalNumberOf15CaAnd15Cb ? record?.totalNumberOf15CaAnd15Cb : "--"
            ),
        },
        {
            title: "Total Amt. Charged",
            key: "totalAmt",
            width: "140px",
            align: "center",
            render: (val, record) => (
                record?.totalAmountCharged ? record?.totalAmountCharged : "--"
            ),
        },
        {
            title: "GSTIN",
            key: "gst",
            align: "center",
            width: "150px",
            render: (val, record) => (
                record?.customerGstin ? record?.customerGstin : "--"
            ),
        },
        {
            title: "PAN",
            key: "pan",
            align: "center",
            width: "150px",
            render: (val, record) => (
                record?.customerPan ? record?.customerPan : "--"
            ),
        },
        {
            title: "Address",
            key: "address",
            align: "center",
            width: "200px",
            render: (val, record) => (
                <>
                    {
                        record?.city ? record?.city : "--"
                    }
                    {
                        ", "
                    }
                    {
                        record?.state ? record?.state : "--"
                    }
                </>
            ),
        },
        {
            title: "E-mail",
            key: "email",
            align: "center",
            width: "150px",
            render: (val, record) => (
                record?.customerEmail ? record?.customerEmail : "--"
            ),
        },
        {
            title: "Phone",
            key: "email",
            align: "center",
            width: "120px",
            render: (val, record) => (
                record?.customerPhone ? record?.customerPhone : "--"
            ),
        },
    ]

    async function onChangeSearch(e) {
        setQueryTermSearch(e)
        if (e.trim().length) {
            let list_ = []
            await searchOrg(e)
                .then(async (res) => {
                    if (res) {
                        res.forEach((elem) => {
                            list_.push({
                                "name": elem.name,
                                "id": elem.id
                            })
                        })
                        setOrgList(list_)
                    }
                })
        } else if (e.length === 0) {
            setFilterRefresh(true)
            setOrgList([])
        }
    }

    async function getCaBillings(filters) {
        setShowLoader(true)
        if (filterValues && !filters) {
            await getBillingsCa(currentPage, filterValues)
                .then((res) => {
                    setBillingsMain(res?.organisationList)
                    setTotalCount(res?.totalCount)
                    setFilterRefresh(false)
                })
                .catch((err) => {
                    notify.error("Error while getting billings!")
                })
                .finally(() => {
                    setShowLoader(false)
                })
        } else {
            await getBillingsCa(currentPage, filters)
                .then((res) => {
                    setBillingsMain(res?.organisationList)
                    setTotalCount(res?.totalCount)
                    setFilterRefresh(false)
                })
                .catch((err) => {
                    notify.error("Error while getting billings!")
                })
                .finally(() => {
                    setShowLoader(false)
                })
        }

    }

    const onTablePageChange = (pagination) => {
        setCurrentPage(pagination.current - 1)
    };

    const filterCall = async () => {
        if (queryDateRange && !queryTermSearch) {
            setShowLoader(true)
            let filter_ = `?fromDate=${new Date(queryDateRange[0]).getTime()}&toDate=${new Date(queryDateRange[1]).getTime()}`
            setFilterValues(filter_)
            getCaBillings(filter_)
        }
        if (queryTermSearch) {
            setShowLoader(true)
            setOrgList([])
            await searchOrg(queryTermSearch)
                .then(async (res) => {
                    let res_ = res
                    let array_ = []
                    res_?.map(element => {
                        array_.push(element.id)
                    });
                    array_ = array_.toString()
                    setCurrentPage(0)
                    if (queryDateRange) {
                        let filter_ = `?organisationId=${array_}&fromDate=${new Date(queryDateRange[0]).getTime()}&toDate=${new Date(queryDateRange[1]).getTime()}`
                        setFilterValues(filter_)
                        getCaBillings(filter_)
                    } else {
                        let filter_ = `?organisationId=${array_}`
                        setFilterValues(filter_)
                        getCaBillings(filter_)
                    }
                })
                .catch((err) => {
                    notify.error("Error searching org")
                })
                .finally(() => {
                    setShowLoader(false)
                })
        }
    }

    const downloadFile = async (filters_) => {
        setShowLoader(true)
        await downloadMainBillings(filters_)
            .then((res) => {
                if (res !== "" && res !== undefined) {
                    FileDownload(res, "billings.xlsx")
                }
                else {
                    notify.error("Not able to download file in given filter!")
                }
            }).catch(err => {
                notify.error("Error while Downloading!")
            }).finally(() => {
                setShowLoader(false)
            })
    }

    const downloadMain = async () => {
        if (queryDateRange) {
            let filter_ = `?fromDate=${new Date(queryDateRange[0]).getTime()}&toDate=${new Date(queryDateRange[1]).getTime()}`
            setFilterValues(filter_)
            await downloadFile(filter_)
        }
        if (queryTermSearch) {
            await searchOrg(queryTermSearch)
                .then(async (res) => {
                    let res_ = res
                    let array_ = []
                    res_?.map(element => {
                        array_.push(element.id)
                    });
                    array_ = array_.toString()
                    setCurrentPage(0)
                    if (queryDateRange) {
                        let filter_ = `?organisationId=${array_}&fromDate=${new Date(queryDateRange[0]).getTime()}&toDate=${new Date(queryDateRange[1]).getTime()}`
                        setFilterValues(filter_)
                        downloadFile(filter_)
                    } else {
                        let filter_ = `?organisationId=${array_}`
                        setFilterValues(filter_)
                        downloadFile(filter_)
                    }
                })
                .catch((err) => {
                    notify.error("Error searching org")
                })
        }
        if (!queryDateRange && !queryTermSearch) {
            downloadFile("")
        }
    }

    const selectionList = (e) => {
        setQueryTermSearch(e.name)
        let filter_ = `?organisationId=${e.id}`
        getCaBillings(filter_)
        setOrgList([])
    }

    useEffect(() => {
        getCaBillings()
    }, [currentPage, filterRefresh])

    return (
        <div className='org'>

            <div className="org_heading">
                <Typography.Title level={2} style={{ marginBottom: ".4rem" }}>15CA/CB Report</Typography.Title>
            </div>
            <div className="org_filters-container" style={{
                margin: "20px 0"
            }}>
                <div className="org_filters-container_searchbox">
                    <Form form={form} style={{ margin: "15px 0", display: 'flex', alignItems: 'center' }}>
                        <Form.Item style={{ margin: 0 }}
                            rules={
                                [
                                    {
                                        validator: (_, value) => {
                                            if(value && value.length > 100){
                                                Promise.reject("Maximum character limit exceeded!");
                                            }

                                            Promise.resolve();
                                        }
                                    }
                                ]
                            }
                        >
                            <Input style={{
                                width: "250px",
                                margin: "0 10px"
                            }} onChange={(e) => onChangeSearch(e.target.value)} placeholder='Search by Customer Name' value={queryTermSearch ? queryTermSearch : ""} />
                            {
                                orgList.length ?
                                    <div className='list_sug'>
                                        <ul>
                                            {
                                                orgList.map((elem, i) => {
                                                    return (
                                                        <li key={i} onClick={() => selectionList(elem)}>{elem.name}</li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                    : ""
                            }
                        </Form.Item>
                        <Button type='primary' onClick={filterCall}>Search</Button>

                        <div className="datefilter" style={{ display: 'flex', alignItems: 'center', marginLeft: '1rem' }}>
                            {/* <Typography.Title level={5} style={{
                            textTransform: "uppercase",

                        }}>Filter by Date </Typography.Title> */}
                            <Form.Item tooltip="Provide from and to date" name={'toFrom'} style={{ marginBottom: 0, marginRight: '.5rem' }}>
                                <RangePicker onChange={(e) => setQueryDateRange(e)} />
                            </Form.Item>
                            <Button type='primary' onClick={filterCall}>Submit</Button>
                        </div>
                        <Tooltip title="Resets all the filter states and sync with original data">
                            <Button icon={<ReplayCircleFilled />} type='ghost' style={{ margin: "0 5px" }} onClick={() => {
                                form.resetFields()
                                setQueryTermSearch('')
                                setQueryDateRange('')
                                setCurrentPage(0)
                                setFilterRefresh(true)
                                setFilterValues()
                            }}>RESET</Button>
                        </Tooltip>
                    </Form>

                </div>

                <div className='org_filters-container_wrapButtons'>
                    <div className='org_filters-container_downloadButton'>
                        <Button type='primary' icon={<DownloadOutlined />} onClick={downloadMain}>Download</Button>
                    </div>
                </div>
            </div>
            <div className="org_table">
                <Table columns={colsCa} dataSource={billingsMain} className='styledAntd' pagination={{
                    pageSize: 10,
                    total: totalCount,
                    showSizeChanger: false,
                    position: ["bottomCenter"],
                    current: currentPage + 1
                }}
                    onChange={onTablePageChange}
                    rowKey={(record) => record?.id}
                    scroll={{ x: '100vw' }}
                />
            </div>
            {
                open &&
                <SubTable hideSubtable={hideSubtable} />
            }
        </div >
    )
}

export default CaBillings
